<object-detection-image-canvas class="w100 h100" [readOnly]="readOnly" [imagePath]="imagePath" [label]="label" (labelChange)="onLabelChange$.next($event)"></object-detection-image-canvas>
 